// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"4ee35279","680":"0e4e4267"}[chunkId] + ".chunk.css";
};